import * as React from 'react'
import { Descriptions, Modal, PageHeader } from 'antd'
import { RouteComponentProps, withRouter } from 'react-router'
import moment from 'moment'

import container from '../../wires/Bootstrapper'
import SERVICE_IDENTIFIER from '../../wires/Identifiers'

import { StresstestParams } from './StresstestParams'
import { StressTestInputModel, StressTestModel, StressTestRow } from '../../models/StressTestModels'
import { TableStresstest } from './TableStresstest'
import { ModalAmount } from './ModalAmount'
import { formatEuro } from '../shared/CurrencyFormat'
import { IStresstestService } from '../../services/StresstestService'
import Button from 'antd/es/button'
import { ArrowRightOutlined, DownloadOutlined, EditOutlined } from '@ant-design/icons'
import { ModalEditNomeStresstest } from './ModalEditNomeStresstest'


class StresstestState extends StressTestModel {
    Mese: number
    Editable: boolean = true

    RowId: string
    RowIndex: number
    MonthIndex: number

    ModalVisible: boolean = false
    ModalEditNomeVisible: boolean = false
    ModalValue: number
    ModalCloseCallback: (value: number) => void
}


class StresstestComp extends React.Component<RouteComponentProps<StresstestParams>, StresstestState> {

    service: IStresstestService

    constructor(props) {
        super(props)


        this.service = container.get(SERVICE_IDENTIFIER.STRESSTEST_SERVICE)
        this.state = new StresstestState()
    }

    componentDidMount() {
        this.setState({ Editable: this.props.match.params.id == null })
        this.loadPage()
    }

    loadPage = async () => {
        let resp = await this.service.GetStressTest(this.props.match.params.id)
        if (resp.IsValid == true) {
            this.setState(resp)
            this.setState({ Mese: moment(resp.MeseRiferimento).month() })
        }
    }

    pushData = async (model: StressTestInputModel) => {
        let resp = await this.service.SaveStressTest(model)
        if (resp.IsValid == true) {
            this.clearIndexes()
            this.setState(resp)
        }
    }

    onCurrencyClick = (callback: (value: number) => void, data: number) => {
        this.setState({ ModalValue: data })
        this.openModal(callback)
    }

    onSaldoCCSave = (value: number) => {
        let model = new StressTestInputModel()
        model.Id = this.state.Id;
        model.SaldoCC = value
        model.FidiCassa = this.state.FidiCassa
        model.Entrate = this.state.Entrate
        model.Uscite = this.state.Uscite
        this.pushData(model)
    }

    onFidiSave = (value: number) => {
        let model = new StressTestInputModel()
        model.Id = this.state.Id;
        model.SaldoCC = this.state.SaldoCC
        model.FidiCassa = value
        model.Entrate = this.state.Entrate
        model.Uscite = this.state.Uscite
        this.pushData(model)
    }

    onCellClick = (row: StressTestRow, rowIndex: number, monthIndex: number, closeCallback: (value: number) => void) => {
        this.setState({
            ModalValue: row.Valori[monthIndex],
            RowId: row.Id,
            RowIndex: rowIndex,
            MonthIndex: monthIndex
        })
        this.openModal(closeCallback)
    }

    onEntrataCellSave = async (value: number) => {
        this.closeModal()
        let model = new StressTestInputModel()
        model.Id = this.state.Id;
        model.SaldoCC = this.state.SaldoCC
        model.FidiCassa = this.state.FidiCassa
        model.Entrate = this.cloneArrayAndReplaceValue(this.state.Entrate, value)
        model.Uscite = this.state.Uscite
        model.MonthIndex = this.state.MonthIndex
        model.RowId = this.state.RowId
        model.Value = value
        this.pushData(model)
    }

    onUscitaCellSave = async (value: number) => {
        this.closeModal()
        let model = new StressTestInputModel()
        model.Id = this.state.Id;
        model.SaldoCC = this.state.SaldoCC
        model.FidiCassa = this.state.FidiCassa
        model.Entrate = this.state.Entrate
        model.Uscite = this.cloneArrayAndReplaceValue(this.state.Uscite, value)
        model.MonthIndex = this.state.MonthIndex
        model.RowId = this.state.RowId
        model.Value = value
        this.pushData(model)
    }

    cloneArrayAndReplaceValue = (array: StressTestRow[], value: number): StressTestRow[] => {
        let copy = JSON.parse(JSON.stringify(array)) as StressTestRow[]
        copy[this.state.RowIndex].Valori[this.state.MonthIndex] = value
        return copy
    }

    clearIndexes = () => {
        this.setState({
            ModalValue: null,
            RowId: null,
            RowIndex: null,
            MonthIndex: null
        })
    }

    closeModal = () => {
        this.setState({ ModalVisible: false, ModalCloseCallback: null })
    }

    toggleEditModal = (visible: boolean) => {
        this.setState({ ModalEditNomeVisible: visible })
    }

    saveNomeStresstest = async (value: string) => {
        let resp = await this.service.SaveNomeStressTest(this.state.Id, value)
        let model = this.state;
        if (resp.IsValid)
            this.setState({ ...model, NomeStressTest: value })
    }

    openModal = (callback: (value: number) => void) => {
        this.setState({ ModalVisible: true, ModalCloseCallback: callback })
    }

    formatMonthYear = (value: Date) => {
        return moment(value).format("MMMM YYYY")
    }

    renderEditableCurrency = (callback: (value: number) => void, value: number) => {
        let content = <b>{formatEuro(value)}</b>
        if (this.state.Editable === true)
            return <a title="Clicca per modificare il valore" onClick={() => this.onCurrencyClick(callback, value)}>{content}</a>

        return content
    }

    renderHint = () => {
        if (this.state.Editable === true)
            return <p>Utilizza le informazioni che possiedi per completare la seguente tabella</p>

        return <></>
    }

    renderUscite = () => {
        if (this.state.Uscite == null) return
        return (
            <>
                <h3>Uscite</h3>
                {this.renderHint()}
                <TableStresstest
                    StressTestId={this.state.Id }
                    titolo="Quali uscite avrò"
                    dataSource={this.state.Uscite}
                    mese={this.state.Mese}
                    editable={this.state.Editable} filtrable={true }
                    onCellClick={
                        (data: StressTestRow, rowIndex: number, monthIndex: number) =>
                            this.onCellClick(data, rowIndex, monthIndex, (value) => this.onUscitaCellSave(value))
                    }
                    onReload={() => this.loadPage()}
                />
            </>
        )
    }

    renderEntrate = () => {
        if (this.state.Entrate == null) return
        return (
            <>
                <h3>Entrate</h3>
                {this.renderHint()}
                <TableStresstest
                    StressTestId={this.state.Id }
                    titolo="Quanto incasserò"
                    dataSource={this.state.Entrate}
                    mese={this.state.Mese}
                    editable={this.state.Editable} filtrable={false}
                    onCellClick={
                        (data: StressTestRow, rowIndex: number, monthIndex: number) =>
                            this.onCellClick(data, rowIndex, monthIndex, (value) => this.onEntrataCellSave(value))
                    }
                    onReload={() => this.loadPage()}
                />
            </>
        )
    }

    renderRisultati = () => {
        if (this.state.Risultati == null) return
        return (
            <>
                <h3>Risultati</h3>
                <TableStresstest
                    StressTestId={this.state.Id}
                    dataSource={this.state.Risultati} filtrable={false}
                    mese={this.state.Mese} result={true }
                />
                <br />
                <Descriptions column={1}>
                    <Descriptions.Item label="Se le tue previsioni sono corrette hai liquidità fino a">
                        <b>{this.formatMonthYear(this.state.PrevCorretteLiquidita)}</b>
                    </Descriptions.Item>
                    <Descriptions.Item label="Nel peggiore dei casi (zero incassi) hai liquidità fino a">
                        <b>{this.formatMonthYear(this.state.ZeroIncassiLiquidita)}</b>
                    </Descriptions.Item>
                </Descriptions>
            </>
        )
    }

    onGoToRettifiche = () => {
        Modal.confirm({
            title: "Rettifiche",
            content: "Passando alla sezione rettifiche i valori non potranno più essere modificati. Vuoi procedere?",
            onOk: () => {
                this.props.history.push(`Dettaglio/${this.state.Id}`)
            }
        })
    }

    onExport = () => {
        this.service.Export(this.props.match.params.id)
    }

    renderButton = () => {
        if (!this.state.Editable)
            return [
                <Button key="edit" type="primary" onClick={() => this.toggleEditModal(true)} icon={<EditOutlined />}>Modifica nome stress test</Button>,
                <Button type="primary" key="download-stresstest" icon={<DownloadOutlined />} onClick={() => this.onExport()}>Esporta stress test</Button>
            ]
        return [
            <Button key="edit" type="primary" onClick={() => this.toggleEditModal(true)} icon={<EditOutlined />}>Modifica nome stress test</Button>,
            <Button key="edit" type="primary" onClick={() => this.onGoToRettifiche()} icon={<ArrowRightOutlined />}>Passa alle rettifiche</Button>,
            <Button type="primary" key="download-stresstest" icon={<DownloadOutlined />} onClick={() => this.onExport()}>Esporta stress test</Button>
        ]
    }

    render() {
        return (
            <PageHeader title={`Stress Test di ${this.state.NomeStressTest}`} onBack={() => this.props.history.goBack()} extra={this.renderButton()}>
                <Descriptions column={1}>
                    <Descriptions.Item label="Quanto ho sul cc aziendale oggi">
                        {this.renderEditableCurrency((value) => this.onSaldoCCSave(value), this.state.SaldoCC)}
                    </Descriptions.Item>
                    <Descriptions.Item label="Quanti fidi di cassa non utilizzati ho">
                        {this.renderEditableCurrency((value) => this.onFidiSave(value), this.state.FidiCassa)}
                    </Descriptions.Item>
                </Descriptions>
                {this.renderUscite()}
                <br />
                {this.renderEntrate()}
                <br />
                {this.renderRisultati()}

                <ModalAmount
                    visible={this.state.ModalVisible}
                    value={this.state.ModalValue}
                    closeModal={() => this.closeModal()}
                    do={value => this.state.ModalCloseCallback(value)} />
                {this.state.ModalEditNomeVisible ?
                    <ModalEditNomeStresstest
                        visible={this.state.ModalEditNomeVisible}
                        value={this.state.NomeStressTest}
                        closeModal={() => this.toggleEditModal(false)}
                        do={value => this.saveNomeStresstest(value)}
                    /> : <></>
                }

            </PageHeader>
        )
    }
}

export const Stresstest = withRouter(StresstestComp)
